import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { SqlPoolCopySource } from 'app/model/pipeline/copysource/sql-pool.copysource';
import { SqlPoolSink } from 'app/model/pipeline/copysink/sql-pool.copysink';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const sqlPoolLinkedServiceMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.sqlPool.connectionType,
    displayName: stringResources.AzureSQLAnalyticsPool_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-SQLPool'
    },
    distinguishTableView: true,
    notShowInTypeSelection: true, // this is a fake linked service and will not show out in type selection
    queryAlias: 'sqlReaderQuery',
    isFirstClass: true,
    supportDatasetV2: true,
    tableColumnNameQuotes: ['[', ']'],
    supportPreCopyScript: true,
    category: ['Azure'],
    supportGetMetadataActivity: true,
    supportStoredProcedureActivity: true,
    disableSinkStoredProcedure: true,
    copySinkTypes: [Metamodel.modelFor(SqlPoolSink).name],
    copySourceTypes: [Metamodel.modelFor(SqlPoolCopySource).name],
    supportFirstClassParameterExperience: true,
    controls: []
};
